import firebaseApp from '../firebase.config';
import Login from "../Login";
import {getColorName} from './Colors';
import {setUserLastActive} from '../UserContext';
import React,{useState,useEffect, useRef, useLayoutEffect} from 'react';
import { useTheme } from '@mui/material/styles';
import Header from "../Header"
import Selection from "./Selection"
import PassedWords from "./PassedWords"
import Square, {square_get_sibling_ordered, square_get_sibling} from "./Square"
import Cairo, {cairoConfig} from "./Cairo"
import Hexagon, {hexagonConfig} from "./Hexagon"
import Voronoi, {voronoiConfig} from "./Voronoi"
import MultiScore from "./MultiScore"
import {useNavigate, Link} from "react-router-dom";
//import { getDatabase, ref, onValue } from "firebase/database";
import { getFirestore, runTransaction } from "firebase/firestore";
import { setDoc, serverTimestamp, deleteField, updateDoc } from "firebase/firestore";
import { collection, query, where, doc, getDoc, getDocs, onSnapshot } from "firebase/firestore"; 

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Avatar from '@mui/material/Avatar';
import Tooltip from "@mui/material/Tooltip";

import NextLevelShow from './NextLevelShow'
import ToolTips from "../game/ToolTips"
import StatusBar from "../game/StatusBar"
import Description from "../game/Description"

import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import Badge from '@mui/material/Badge';

import { styled } from '@mui/material/styles';
import { pink } from '@mui/material/colors';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getStepButtonUtilityClass } from '@mui/material';

import { SnackbarProvider, useSnackbar } from 'notistack';

import Dictionary from "../Dictionary";
import { DirectionsWalkRounded, NoEncryptionGmailerrorredOutlined } from '@mui/icons-material';

import { Dimensions, ScrollView, View, Image } from 'react-native';

import { Animated, StyleSheet, SafeAreaView } from "react-native";
import {handleFbFriends, ModalInviteFriends} from './ModalInviteFriends';
import Error from '../Error';

import ReactDOM from 'react-dom/client';
import ReactDOMServer from 'react-dom/server';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import {
    Canvg,
    presets
  } from 'canvg'
  

const Dwindow = Dimensions.get("window");
const Dscreen = Dimensions.get("screen");

//const database = getDatabase();
const db = getFirestore(firebaseApp);

export default function Board(props) {

    const Vl = useRef([]);
    const letterVl = useRef({});
    const SelectionRef = useRef()
    const CrosswordRef = useRef()
    const PassedWordsRef = useRef();
    const system_update = useRef(0);

    const [isFinish, setFinish] = useState(false);

    const data = useRef(props.gamedata)
    const ToolTipRef = useRef()
    const HeaderRef = useRef();
    const timer_help_blink = useRef();
    const drawObject = useRef();

    const [offsetHeight, setHeight] = useState(0);
    const [checkFinishLevel, setCheckFinishLevel] = useState({gameId: null, level: null, time: null});
    const timer_check_finish_level = useRef();

    const [passed_words, setUpPassedWords] = useState(null);
    const ref_passed_words = useRef(null);
    
    const sibling_orderedRef = useRef();

    const [drawboard, SetBoard] = useState()
    const [level, SetLevel] = useState()
    const [players, setPlayersScore] = useState({});
    const playersRef = useRef(null);
    const statusBarRef = useRef();

    const fbContextId = useRef();

    const [last_heroes, setLastHeroes] = useState({});
    //const [last_words, setLastWords] = useState(null);
    const [playLevel, startPlayLevel] = useState(false);
    const [alreadyFirstRead, setAlreadyFirstRead] = useState(false);
    const [playButtonDisabled, setPlayButtonDisabled] = useState(false);
    const [last_current_word, setLastCurrentWord] = useState();
    const [largeBoard, setLargeBoardDimensions] = useState(1 && Dwindow.width >= 460)
    const [dimensions, setDimensions] = useState({ Dwindow, Dscreen });

    const [openModalInviteFriends, setOpenModalInvite] = React.useState(false);
    const afterLevelInit = useRef(false);
    const gameOwnerRef = useRef(null);
    const globTheme = useTheme();

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    //const UpdateFunc = useRef(updateUsedRaw);

    var mv_real_words = {}

    var sibling_ordered = [];
    var sibling = {};
    
    let navigate = useNavigate();

    
    
    useEffect(() => {
        const subscription = Dimensions.addEventListener(
        "change",
        (e) => {
            //console.log('W:', e.window);
            //console.log('S:', e.screen);
            setDimensions({...e});

            setLargeBoardDimensions(1 && e.window.width >= 460);
        }
        );
        return () => subscription?.remove();
    });
    
    useEffect(() => {

        // console.log('Hello here againe - 1');
        if (!props.level || !checkFinishLevel.gameId || !checkFinishLevel.level || !checkFinishLevel.time)
            return;
        // console.log('Hello here againe - 2', checkFinishLevel);

        async function checkFinishLevelTimeout() {
            clearTimeout(timer_check_finish_level.current);
            
            if (props.level != checkFinishLevel.level ||
                props.gamedata.gameId != checkFinishLevel.gameId)
                return;

            // console.log('Hello here againe!');

            const sfDocRef = doc(db, "current_passed_words", props.gamedata.gameId);
                
            await runTransaction(db, async (transaction) => {
                // This code may get re-run multiple times if there are conflicts.
                return transaction.get(sfDocRef).then((sfDoc) => {
                    if (!sfDoc.exists) {
                        return;
                    }
                    let list2 = sfDoc.data();
                    if (list2 && Object.keys(list2).length >= props.gamedata.level_words.length) {
                        
                        let period = 5*1000;
                        timer_check_finish_level.current = setTimeout(() => checkFinishLevelTimeout(), period);
                        
                        transaction.set(sfDocRef, { system: 'system:' + Date.now() }, { merge: true });
                    };
                });
            }).then(() => {
                
                // console.log("Transaction successfully committed!");
                

            }).catch((error) => {
                //console.log("Transaction failed: ", error);
            });
        }
        
        let period = 5*1000;
        timer_check_finish_level.current = setTimeout(() => checkFinishLevelTimeout(), period);

        return () => clearTimeout(timer_check_finish_level.current);
    }, [props.gamedata.gameId, props.level, checkFinishLevel]);

    function changeToolTip() {

        // console.log('Before Just scrollIntoView', CrosswordRef);
        if (!CrosswordRef.current)
            return;

            CrosswordRef.current.scrollIntoView({
            behavior: "smooth",
          }); 
        // console.log('Just scrollIntoView');
    }

    function AddWordHistory(words, gameId) {
        Object.keys(words).map(word => AddItemWordHistory(word, gameId));
    }

    function AddItemWordHistory(word, gameId) {

        system_update.current = Date.now();
        
        if ("system" == word)
            return;

        //console.log('AddItemWordHistory word:', word);
        let data = props.gamedata;

        let level_words_keys;
        let level_words2_keys;

        if (data.level_words_keys)
            level_words_keys = JSON.parse(data.level_words_keys);

        if (data.level_words2_keys)
            level_words2_keys = JSON.parse(data.level_words2_keys);

        let iword = data.level_words.findIndex((x) => x === word)

        let word2 = "";
      
        if (data.level_words2 && data.level_words2[iword])
            word2 = data.level_words2[iword];

        let show_word = '';

        if (word2 && level_words2_keys && level_words2_keys[iword]) {
            
            show_word = word2 + '-' + level_words2_keys[iword];

        } else if (word && level_words_keys && level_words_keys[iword]) {
            
            show_word = word + '-' + level_words_keys[iword];
        };
        
        if (!props.user.lastWord.current.includes(show_word)) {
            props.user.lastWord.current = [show_word, ... props.user.lastWord.current];
            props.user.lastWordShort.current = word;
            props.user.lastWordShortKey.current = show_word;
            props.user.lastWordGameId.current = gameId
                
        };
    }

    function DictWord(word) {

        let url = '/dict/';
        url = url + word;
        navigate(url);
        //setDictWord(word);
        //setDictShow(true);
    }

    useLayoutEffect(() => {
        if (CrosswordRef.current) {
            setHeight(CrosswordRef.current.offsetHeight);
        }
    }, []);

    useEffect (() => {

        afterLevelInit.current = false;
        SetLevel(props.level)
        //setUpPassedWords({})
        setUpPassedWords(null);
        
        setAlreadyFirstRead(false);
        // setLastWords(null);
        
        ref_passed_words.current = null
        //fetchGameData();

        let gameId = data.current.gameId

        if (!props.user.levelPromoShowed[gameId]) {
            props.user.levelPromoShowed[gameId] = {}
        }

        if (!props.user.levelPromoShowed[gameId][props.level]) {

            if (Object.keys(props.user.levelPromoShowed[gameId]).length > 0)
                startPlayLevel(false);
            else
                startPlayLevel(true);

            props.user.levelPromoShowed[gameId][props.level] = 1;
        }
        else {
            startPlayLevel(true);
        };

        // startPlayLevel(false);
        /*
        if (data.current.multigame) {
            startPlayLevel(false);
        } else {
            // startPlayLevel(true);
        }*/
       if (gameId)
       return onSnapshot(doc(db, "current_passed_words", gameId), {includeMetadataChanges: true}, (docum) => {
        // console.log('AAAA');
        
        const source = docum.metadata.hasPendingWrites ? "Local" : "Server";
        // enqueueSnackbar('I love snacks.');
        //console.log(docum.metadata);
        setUserLastActive(props.user.uid);

        var list = docum.data();
        
        if (list )
            startPlayLevel(true);
        else {
            
            // Show Last Word from previos Level.
            // Get previous words.
            // 
            // console.log('Before Last', props.user.lastWordShortKey.current);
            // props.user.lastWordShortKey.current 
            if (props.user.lastWordGameId.current == gameId && props.user.lastWordShortKey.current && props.user.lastSnackbar.current != props.user.lastWordShortKey.current) {
                
                props.user.lastSnackbar.current  = props.user.lastWordShortKey.current 
                // Show last word from previous level
                let newlink = '/dict/' + props.user.lastWordShortKey.current;

                let style = {};
                if ('light' == globTheme.palette.mode) {
                    style.color = globTheme.palette.secondary.main;
                };
                
                let idSnackbar 
                if (enqueueSnackbar) 
                    idSnackbar = enqueueSnackbar(<Typography>Переглянути <Link  style={style} to={newlink} onClick={() => {navigate(newlink, {replace: true}); closeSnackbar(idSnackbar);}}>{props.user.lastWordShort.current}</Link> в словнику!</Typography>, { autoHideDuration: 2050, anchorOrigin:{ vertical: 'bottom', horizontal: 'right' },});
            }
            /*
            const getPost = async () => {
                //console.log('Before Last2');
                const docSnap = await getDoc(doc(db, "last_passed_words", gameId));
                
                if (docSnap.exists())
                    setLastWords( Object.entries(docSnap.data()))

                //console.log('Last:',  Object.entries(docSnap.data()));
              }
              getPost().catch(console.error);
            */
        }
        /*
        var res = [];
        for (let item in list) {
            res.push(item);
            //res.push([]);
            let word = item;
            // setUpPassedWords((prev) => (-1 == prev.indexOf(word)) ? ([...prev, word]) : (prev))
          
        }*/
        // Maybe Error, check is the first time Select
        /*
        if (list && "Server" == source && null == ref_passed_words.current && Object.keys(list).length >= data.current.level_words.length) {
            console.log('End Level Error!')

            const docRef = doc(db, "current_passed_words", gameId);
            updateDoc(docRef, {"test": deleteField()});
            setDoc(docRef, {"test": serverTimestamp()}, { merge: true });
        }*/

        /*
        if (list ) {
            setAlreadyFirstRead(true);
            console.log('List:',list)

            for (const [key, value] of Object.entries(list)) {

                //console.log(`${key}: ${value}`);
                console.log('Current:', ref_passed_words.current)
                //if (null!==ref_passed_words.current)
                //    console.log(key, ref_passed_words.current[key])
                if ((null == ref_passed_words.current )||  (null!==ref_passed_words.current && undefined === ref_passed_words.current[key]))
                    enqueueSnackbar(key, { autoHideDuration: 750, anchorOrigin:{ vertical: 'top', horizontal: 'right' },});
              }
        }*/

        ref_passed_words.current = list
        
        if (912 == props.level && list && Object.keys(list).length >= data.current.level_words.length) {
            setFinish(true);
        };

        if (912 != props.level && list && Object.keys(list).length >= data.current.level_words.length) {
            // Lets  Monitor && level up
            // if (request.resource.data.keys().hasOnly(['lets_level_up']))
            // && (request.resource.data.get('lets_level_up', 0) == resource.data.get('current_level', 0) )
            setCheckFinishLevel({gameId:gameId, level:props.level, time: Date.now() + 5*1000})
            
        };

        //setUpPassedWords(list)
        // console.log('LIST3.1', list);
        // console.log('LIST3.2', Object.keys(list));

        list && list["system"] && delete list["system"]; 

        setUpPassedWords((prev) => {
            // console.log('PREV2', prev);
            // console.log('LIST2', list);
            if (null != prev ) {
                let p1 = Object.keys(prev);
                let l1 = [];
                // console.log('PREV', prev);
                // console.log('LIST', list);
                if (null !== list && undefined !== list) {
                    l1 = Object.keys(list);
                }
                
                let difference = l1.filter(x => !p1.includes(x) );
                // console.log('DIFF', difference);
                if (0 < difference.length) {

                    setLastCurrentWord(difference[0]);

                    // Show SnackBar User +1 score
                    if (afterLevelInit.current) {
                        show_diff_score(difference, list);
                    }
                }
            }; 
            
            if (list === undefined)
                return ({});
            else {
                AddWordHistory(list, gameId);
                return list;
            };
        });

        afterLevelInit.current = true;
        HelpBlinkTimeout(0);
        //setUpPassedWords((prev) => [...prev, ...res].filter((item, pos) => [...prev, ...res].indexOf(item) === pos))
        

      });

    }, [data.current.gameId, data.current.current_level])

    useEffect (() => {
        HelpBlinkTimeout(0);
        return () => clearTimeout(timer_help_blink.current);
    }, [data.current.gameId, data.current.current_level])

    async function toPng(data) {

        const preset = presets.offscreen()
        
        const {
            width,
            height,
            svg
        } = data
        // const canvas = new OffscreenCanvas(width, height)
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d')
        const v = await Canvg.from(ctx, svg, preset)
        
        /**
         * Resize SVG to fit in given size.
         * @param width
         * @param height
         * @param preserveAspectRatio
         */
        //v.resize(width, height, 'xMidYMid meet')
        
        // Render only first frame, ignoring animations and mouse.
        await v.render()
        
        return canvas.toDataURL()
        // const blob = await canvas.convertToBlob()
        /*const arrayBuffer =  blob.arrayBuffer()  
        var base64 = btoa(
            new Uint8Array(arrayBuffer)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          );*/      

        //return base64;
        //const pngUrl = new FileReaderSync().readAsDataURL(blob);

        //const pngUrl = URL.createObjectURL(blob)
        
        //return pngUrl
    }

    async function getBase64SVG(htmlString) {

        
        //var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // svg.setAttribute('viewBox', "0 0 305 305");
        //svg.setAttribute('style', 'border: 0px');
        // svg.setAttribute('width', '400');
        // svg.setAttribute('height', '450');
        
        // const htmlString = ReactDOMServer.renderToString(<PassedWords onlySVG = {true} largeBoard={largeBoard} Vl={Vl.current} gamedata={data.current} passed_words={['кобила']} players={playersRef.current} offsetHeight= {offsetHeight} sibling_ordered={sibling_orderedRef.current} level={data.current.current_level}/>)
        // console.log('html1', element);

        // console.log('html', htmlString);
        
        //root2.render(<circle cx="50" cy="50" r="40" stroke="black" strokeWidth="3" fill="red" />);

         //element = <svg  xmlns="http://www.w3.org/2000/svg"  ><circle cx="50" cy="50" r="40" stroke="black" strokeWidth="3" fill="red" /></svg>
         //var s1 = 'data:image/svg+xml,' + escape(ReactDOMServer.renderToStaticMarkup((element)));
        
        //var htmlString = 'data:image/svg+xml;base64,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';
        //var htmlString = '<svg id="id_cross_select" xmlns="http://www.w3.org/2000/svg" class="hilite-mark2" viewBox="0 0 305 305" style="width: 100%; position: absolute; left: 0px; top: 0px; z-index: -1;"><g transform="translate(0,0)scale(1)"><g class="box" transform="translate(131.35000000000002,131.07500000000002)scale(0.144)"><polygon fill="#ffcdd2" stroke="grey" fill-opacity="0.8" stroke-width="1" points="300,150 225,280 75,280 0,150 75,20 225,20" transform="" transform-origin="center"></polygon></g><g class="box" transform="translate(163.8,149.8)scale(0.144)"><polygon fill="#ffcdd2" stroke="grey" fill-opacity="0.8" stroke-width="1" points="300,150 225,280 75,280 0,150 75,20 225,20" transform="" transform-origin="center"></polygon></g><g class="box" transform="translate(131.35000000000002,168.525)scale(0.144)"><polygon fill="#ffcdd2" stroke="grey" fill-opacity="0.8" stroke-width="1" points="300,150 225,280 75,280 0,150 75,20 225,20" transform="" transform-origin="center"></polygon></g><g class="box" transform="translate(163.8,187.25)scale(0.144)"><polygon fill="#ffcdd2" stroke="grey" fill-opacity="0.8" stroke-width="1" points="300,150 225,280 75,280 0,150 75,20 225,20" transform="" transform-origin="center"></polygon></g><g class="box" transform="translate(131.35000000000002,205.975)scale(0.144)"><polygon fill="#ffcdd2" stroke="grey" fill-opacity="0.8" stroke-width="1" points="300,150 225,280 75,280 0,150 75,20 225,20" transform="" transform-origin="center"></polygon></g></g></svg>'
        var pngUrl = await toPng({
            width: 100,
            height: 100,
            svg: htmlString
          })

        console.log('pngUrl:', pngUrl);
        return pngUrl;
        
        //return pngUrl;

        //var svg = document.querySelector('svg');
        /*var xml = new XMLSerializer().serializeToString(svg);
        console.log('b64_xml:', xml);
        // make it base64s      
        var svg64 = btoa(xml);
        var b64Start = 'data:image/svg+xml;base64,';
        var image64 = b64Start + svg64;

        console.log('b64:', image64);*/ 
    }
    async function UpdateStatus(event, param) {

        var word = param.word;
        var svg_html = param.svg;
        //var pp = <PassedWords largeBoard={largeBoard} Vl={Vl.current} gamedata={data.current} passed_words={[param]} players={playersRef.current} offsetHeight= {offsetHeight} sibling_ordered={sibling_orderedRef.current} level={data.current.current_level}/>
        
        //var base64Picture = await getBase64SVG(pp);
        //console.log('pp', base64Picture);

        if (!window.FBInstant) 
            return;

        console.log('updateAsync 2 !!');
        if (!fbContextId.current || fbContextId.current != window.FBInstant.context.getID())
            return;

        //var base64Picture = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAwBQTFRF7c5J78kt+/Xm78lQ6stH5LI36bQh6rcf7sQp671G89ZZ8c9V8c5U9+u27MhJ/Pjv9txf8uCx57c937Ay5L1n58Nb67si8tVZ5sA68tJX/Pfr7dF58tBG9d5e8+Gc6chN6LM+7spN1pos6rYs6L8+47hE7cNG6bQc9uFj7sMn4rc17cMx3atG8duj+O7B686H7cAl7cEm7sRM26cq/vz5/v767NFY7tJM78Yq8s8y3agt9dte6sVD/vz15bY59Nlb8txY9+y86LpA5LxL67pE7L5H05Ai2Z4m58Vz89RI7dKr+/XY8Ms68dx/6sZE7sRCzIEN0YwZ67wi6rk27L4k9NZB4rAz7L0j5rM66bMb682a5sJG6LEm3asy3q0w3q026sqC8cxJ6bYd685U5a457cIn7MBJ8tZW7c1I7c5K7cQ18Msu/v3678tQ3aMq7tNe6chu6rgg79VN8tNH8c0w57Q83akq7dBb9Nld9d5g6cdC8dyb675F/v327NB6////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/LvB3QAAAMFJREFUeNpiqIcAbz0ogwFKm7GgCjgyZMihCLCkc0nkIAnIMVRw2UhDBGp5fcurGOyLfbhVtJwLdJkY8oscZCsFPBk5spiNaoTC4hnqk801Qi2zLQyD2NlcWWP5GepN5TOtSxg1QwrV01itpECG2kaLy3AYiCWxcRozQWyp9pNMDWePDI4QgVpbx5eo7a+mHFOqAxUQVeRhdrLjdFFQggqo5tqVeSS456UEQgWE4/RBboxyC4AKCEI9Wu9lUl8PEGAAV7NY4hyx8voAAAAASUVORK5CYII=';
        //var base64Picture = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Ccircle%20cx%3D%2250%22%20cy%3D%2250%22%20r%3D%2240%22%20stroke%3D%22black%22%20stroke-width%3D%223%22%20fill%3D%22red%22%3E%3C/circle%3E%3C/svg%3E';
        //var base64Picture = 'data:image/svg+xml;base64,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';

        // var base64Picture = await getBase64SVG(svg_html);
        // Рівень ${data.current.current_level}.\n 

        var uid = props.user.uid;
        var score = playersRef.current ? playersRef.current[uid].score : 0;
        if (ref_passed_words.current && !ref_passed_words.current[word]) {
            score++;
        }

        window.FBInstant.updateAsync({
            action: 'CUSTOM',
            cta: 'Грати разом',
            image: param.base64,
            text: `${props.user.FbUser.playerName} - ${score}`,
            template: '',
            data: {gameId: data.current.gameId, source:'FB'},
            strategy: 'IMMEDIATE',
            notification: 'NO_PUSH',
          }).then(function() {
            // closes the game after the update is posted.
            console.log('Just sent updateAsync!!');
          }).catch((err) => {console.log('Error sent updateSync', err)});

        /*
        var uid = props.user.uid;
        var game_score = playersRef.current ? playersRef.current[uid].game_score : 0;
        
        if (ref_passed_words.current && !ref_passed_words.current[param]) {
            game_score++;
        }

        
        var nameLeaderboard = 'multigame_current_level.' + window.FBInstant.context.getID();
        console.log('TRY to set Leaderboard ' + nameLeaderboard);

        window.FBInstant.getLeaderboardAsync(nameLeaderboard)
          .then(function(leaderboard) {
            return leaderboard.setScoreAsync(game_score);
          })
          .then(function(entry) {
            console.log('My score is:', entry.getScore()); // 42
          });

        
        console.log('before upddate leaderboard'); // 42
        window.FBInstant.updateAsync({
            action: "LEADERBOARD",
            name: nameLeaderboard
        })
        .then(function(){
            console.log('after upddate leaderboard'); // 42
        }).catch(function(error) {
            // Error posting message
            console.log('Error upddate leaderboard', error); // 42
        });*/
    }

    function show_diff_score(difference, list) {

        if (!data.current.multigame) {
            return;
        };
        //console.log('players:', playersRef);
        //return
        difference.forEach((x) => {
            
            let item = playersRef.current[list[x]];

            if (!item || !list[x])
                return;

            // console.log('UUU LOG', item, x, props.user.userPhotos.current);
            let icon = <Badge 
                overlap="circular"
                badgeContent= "+1" 
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}

                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: item.color,
                      color: globTheme.palette.getContrastText(item.color)
                    }
                  }}
                  >
                <Tooltip title={item.name?item.name:""}>
                <Avatar
                    alt={item.name}
                    src={props.user.userPhotos.current[list[x]]}
                    style={{border: '5px solid ' + item.color}}
                    sx={{ width: 36, height: 36}}
                    />
                </Tooltip>
                </Badge>

            enqueueSnackbar(
            <Stack direction="row" spacing={2}   justifyContent="center" alignItems="center">
                <Typography>«{x.toUpperCase()}» знайдено!</Typography>
                {icon}
            </Stack>
            , { autoHideDuration: 5000, anchorOrigin:{ vertical: 'bottom', horizontal: 'right' },});
        });
    }
    
    function HelpBlinkTimeout(count) {
        clearTimeout(timer_help_blink.current);
        if (count > 4)
            count = 1;
    
        if ((count > 0) && SelectionRef.current )
        {
           SelectionRef.current.lets_help_blink_thefirst_timeout(count);
        }

        let period = 3*60*1000;
        
        if (props.level && props.level < 3)
            period = 12*1000;

        timer_help_blink.current = setTimeout(() => HelpBlinkTimeout(1 + count), period);
    }

    function makeScaleBoard(x,y,scale) {
        
        //console.log("makeScaleBoard2", largeBoard);
        if (largeBoard)
            return;
        
        //console.log("makeScaleBoard22", largeBoard);

        drawObject.current && drawObject.current.makeScale(x,y,scale, largeBoard);
        PassedWordsRef.current && PassedWordsRef.current.makeScale(x,y,scale, largeBoard);
    }

    function getCurrentPassedList() {
        return ref_passed_words.current;
    };

    useEffect (() => {
        
        playersRef.current = null
        gameOwnerRef.current = null

        if (!data.current.multigame) {
         
            // rgb(238, 247, 158)
            let data_player = {uid:props.user.uid, color: "#800000" /*'maroon'*/, name: (props.user.game_profile.current && props.user.game_profile.current.show_name) ? props.user.game_profile.current.show_name: props.user.displayName, score: data.current.current_level}

            setPlayersScore({[props.user.uid] : data_player})
            return;
        }

        // Multigame
        let gameId = data.current.gameId
        return onSnapshot(doc(db, "meta_data_games", gameId), {includeMetadataChanges: true}, async (doc) => {
            var list = doc.data();
            
            if (!list) {
                // Error )) 
                // Have to Clear UserContext Before new Login
                console.log('NODATA meta_data_games', gameId);
                setPlayButtonDisabled(true);
                setPlayersScore([]);
                setLastHeroes([]);
                

                return; 
            };

            fbContextId.current = list['fb_contextId'];
           
            // if (list['players'][props.user.uid])
            //     fbContextId.current = list['players'][props.user.uid]['fb_contextId'];
           

            //console.log(list['players']);
            if (!data.current.multigame || (list && list['players'] && 1 < Object.keys(list['players']).length))
                setPlayButtonDisabled(false);
            else
                setPlayButtonDisabled(true);

            for (var key in list['players']) {
                list['players'][key].color = getColorName(globTheme.palette.mode, list['players'][key].color);
                list['players'][key].uid = key;
                //list['players'][key].photo = await props.user.getUserPhotoURL(key);
            };

            setPlayersScore(list['players'])
            playersRef.current = list['players']
            gameOwnerRef.current = list['owner'];
            setLastHeroes(list['last_heroes'])
            
        });
    }, [props.user, data.current.gameId, data.current.current_level])


    useEffect(() => {

        if (!data.current.multigame) 
            return;
        
        if (!window.FBInstant) 
            return;
        
        (async () => {
        const docRef = doc(db, "meta_data_games", data.current.gameId);
        console.log('Check Multigame Match Async');
        const docSnap = await getDoc(docRef);   
        let m_data = docSnap.data();
        if (/*m_data.fb_contextId && m_data.players && m_data.players[props.user.uid] 
            && m_data.fb_contextId === */
            m_data.players[props.user.uid].fb_group_contextId)
        {
            console.log('m_data.fb_contextId', m_data.fb_contextId);
            console.log('window.FBInstant.context.getID()', window.FBInstant.context.getID())
            console.log('if TRUE', window.FBInstant.context.getID() && window.FBInstant.context.getID().toString() == m_data.fb_contextId);

            /// Already in Group
            if (window.FBInstant.context.getID() 
                && window.FBInstant.context.getID().toString() == m_data.fb_contextId) {
                // Already in Correct Context
                console.log('Already in Correct Context');
                return;
            };

            // Lets Switch to Correct Context
            console.log('TRY to switch to Correct Context', m_data.fb_contextId);

            await window.FBInstant.context
            .switchAsync(m_data.fb_contextId)
            .then(function() {
                console.log('Context777:', window.FBInstant.context.getID());
                return;
            })
            .catch((err) => {
                console.log('AFTER TRY ERROR');
                console.log(err);
            });
            console.log('Context8:', window.FBInstant.context.getID());
            console.log('AFTER TRY to switch to Correct Context');

        } 

        /// Already in Group
        if (window.FBInstant.context.getID() 
            && window.FBInstant.context.getID().toString() == m_data.fb_contextId) {
            // Already in Correct Context
            console.log('Already2 in Correct Context');
            return;
        };

        // Have to add user to context
        console.log('Check 3, Context1:', window.FBInstant.context.getID());

        window.FBInstant
        .checkCanPlayerMatchAsync()
        .then(canMatch => {
            if (canMatch) {
                window.FBInstant
                .matchPlayerAsync('multigame' + data.current.gameId, true, true)
                .then(function() {
                    console.log('Check 4, After match Async');
                    let fb_contextId = window.FBInstant.context.getID();
                    fbContextId.current = fb_contextId;
                    // 4441782899279329
                    setDoc(docRef, {
                        fb_contextId: fb_contextId, 
                        players: {
                            [props.user.uid]:
                                {fb_group_contextId: fb_contextId}
                        }}, { merge: true })
                    .then(() => {})
                    .catch((error) => {console.log('Check 5, Error', error)});
                })
                .catch ((err) => {
                    console.log('Check 5, Error', err);
                    console.log('Check 5, Context5:', window.FBInstant.context.getID());
                });
                
                //console.log('After async match');
            } else {
                //console.log('Cant match');
            }
        });
        
        })();

    }, [props.user, data.current.gameId]);

    useEffect(() => {

        if (!fbContextId.current)
            return;

        if (!window.FBInstant) 
            return;

        /*
        // New Context
        window.FBInstant.context
        .switchAsync(fbContextId.current)
        .then(function() {
            // console.log('Context777:', window.FBInstant.context.getID());
        })
        .catch((err) => {});*/

    }, [fbContextId.current]);

    useEffect(() => {
        if (null == level)
            return
        
        data.current = props.gamedata
        let game_mode = data.current.board_type
        // console.log('Game:', props.gamedata);
        // console.log('Game1:', [largeBoard, level, passed_words, props.palettemode]);
        
        let crossword;
        let crossword_an_footer;
        let grid_area;
        let pm_xword_body;
        let mainbody;

        switch(game_mode) {
            case 'square':
                
                sibling_ordered = square_get_sibling_ordered(data.current.board_size);
                sibling_orderedRef.current = sibling_ordered;
                sibling = square_get_sibling(data.current.board_size);
                // let t = DrawSquare(data.current, props.level, props.onIntroClick)
                // SetBoard(t);
                let square = <Square onIntroClick = {props.onIntroClick} palettemode={props.palettemode} largeBoard={largeBoard} ref={drawObject} init={true} color="#FFF" gamedata={data.current} Vl={Vl} letterVl={letterVl} SelectionRef={SelectionRef} level={level}/>
                
                 crossword = React.createElement('div', { ref:CrosswordRef, className:"crossword", style:{paddingTop:"0px"}},  square, <PassedWords largeBoard={largeBoard} ref={PassedWordsRef} Vl={Vl.current} gamedata={data.current} passed_words={passed_words} players={players} updateUsedRaw = {updateUsedRaw} offsetHeight= {offsetHeight} sibling_ordered={sibling_ordered} level={level}/>,<Selection ref={SelectionRef} playersRef={playersRef} AddItemWordHistory={AddItemWordHistory} UpdateStatus={UpdateStatus}  largeBoard={largeBoard} makeScaleBoard={makeScaleBoard} muted={props.muted}  ToolTipObj={ToolTipRef} Vl={Vl.current} letterVl={letterVl} passed_words={passed_words} sibling={sibling} sibling_ordered = {sibling_ordered} gamedata={data.current} offsetHeight= {offsetHeight} level={level}/>);
                 crossword_an_footer = React.createElement('div', {className:"crossword-and-footer", style:{paddingTop: "0px", paddingBottom: "5px"}}, crossword);
                 grid_area = React.createElement('div', {className:"grid-area scrollable noselect", style:{marginTop:0, paddingTop: "0px", overflow: "hidden", width: "335px"}}, crossword_an_footer);
                 pm_xword_body = React.createElement('div', {className:"pm-xword-body puzzle-type-wordsearch3", style:{marginTop:0, paddingTop: "0px", fontFamily: "short_filmsmedium"}}, grid_area);
                 mainbody = React.createElement('div', {onMouseOver:(e) => SelectionRef.current.handleBoxToggle(e), className:"main-body", style:{marginTop:0, paddingTop: "0px", textAlign: "center"}}, pm_xword_body);
                SetBoard(mainbody);
                
                break;
            case 'cairo':
        
                sibling_ordered = cairoConfig.sibling_ordered;
                sibling_orderedRef.current = sibling_ordered;
                sibling = cairoConfig.sibling;
                
                let cairo = <Cairo palettemode={props.palettemode} largeBoard={largeBoard} ref={drawObject} init={true} color="#FFF" gamedata={data.current} Vl={Vl.current} letterVl={letterVl.current} SelectionRef={SelectionRef} level={level}/>
                crossword = React.createElement('div', { ref:CrosswordRef, className:"crossword", style:{marginTop:0, paddingTop:"0px", minHeight: largeBoard? "450px": "368px", width: largeBoard? "450px": "368px"}}, cairo, <PassedWords ref={PassedWordsRef} largeBoard={largeBoard} Vl={Vl.current} gamedata={data.current} updateUsedRaw = {updateUsedRaw} passed_words={passed_words} players={players} offsetHeight= {offsetHeight} sibling_ordered={sibling_ordered} level={level}/>,<Selection ref={SelectionRef} playersRef={playersRef} AddItemWordHistory={AddItemWordHistory} UpdateStatus={UpdateStatus}  largeBoard={largeBoard} makeScaleBoard={makeScaleBoard} muted={props.muted}  ToolTipObj={ToolTipRef} Vl={Vl.current} letterVl={letterVl} passed_words={passed_words} sibling={sibling} sibling_ordered = {sibling_ordered} gamedata={data.current} offsetHeight= {offsetHeight} level={level}/>);
                crossword_an_footer = React.createElement('div', {className:"crossword-and-footer", style:{marginTop:0, paddingTop: "0px", paddingBottom: "0px"}}, crossword);
                grid_area = React.createElement('div', {className:"grid-area scrollable noselect", style:{marginTop:0, paddingTop: "0px", overflow: "hidden", width: "100%"}}, crossword_an_footer);
                pm_xword_body = React.createElement('div', {className:"pm-xword-body puzzle-type-wordsearch3", style:{marginTop:0, paddingTop: "0px", fontFamily: "short_filmsmedium"}}, grid_area);
                mainbody = React.createElement('div', {onMouseOver:(e) => SelectionRef.current.handleBoxToggle(e), className:"main-body", style:{marginTop:0, paddingTop: "0px", textAlign: "center"}}, pm_xword_body);
                
                SetBoard(mainbody);

                break;
                //return <Cairo init={true} color="white" gamedata={data.current}/>;
            case 'hexagon':
                sibling_ordered = hexagonConfig.sibling_ordered;
                sibling_orderedRef.current = sibling_ordered;

                sibling = hexagonConfig.sibling;
                
                let hexagon = <Hexagon palettemode={props.palettemode} largeBoard={largeBoard} ref={drawObject} init={true} color="#FFF" gamedata={data.current} Vl={Vl.current} letterVl={letterVl.current} SelectionRef={SelectionRef} level={level}/>
                crossword = React.createElement('div', { ref:CrosswordRef, className:"crossword", style:{marginTop:0, paddingTop:"0px", minHeight: largeBoard? "450px": "368px", width: largeBoard? "450px": "368px"}}, hexagon, <PassedWords ref={PassedWordsRef} largeBoard={largeBoard} Vl={Vl.current} gamedata={data.current} updateUsedRaw = {updateUsedRaw} passed_words={passed_words} players={players} offsetHeight= {offsetHeight} sibling_ordered={sibling_ordered} level={level}/>,<Selection ref={SelectionRef} playersRef={playersRef} AddItemWordHistory={AddItemWordHistory} UpdateStatus={UpdateStatus} largeBoard={largeBoard} makeScaleBoard={makeScaleBoard} muted={props.muted}  ToolTipObj={ToolTipRef} Vl={Vl.current} letterVl={letterVl} passed_words={passed_words} sibling={sibling} sibling_ordered = {sibling_ordered} gamedata={data.current} offsetHeight= {offsetHeight} level={level}/>);
                crossword_an_footer = React.createElement('div', {className:"crossword-and-footer", style:{marginTop:0, paddingTop: "0px", paddingBottom: "0px"}}, crossword);
                grid_area = React.createElement('div', {className:"grid-area scrollable noselect", style:{marginTop:0, paddingTop: "0px", overflow: "hidden", width: "100%"}}, crossword_an_footer);
                pm_xword_body = React.createElement('div', {className:"pm-xword-body puzzle-type-wordsearch3", style:{marginTop:0, paddingTop: "0px", fontFamily: "short_filmsmedium"}}, grid_area);
                mainbody = React.createElement('div', {onMouseOver:(e) => SelectionRef.current.handleBoxToggle(e), className:"main-body", style:{marginTop:0, paddingTop: "0px", textAlign: "center"}}, pm_xword_body);
                
                SetBoard(mainbody);
                break;
            case 'voronoi':
                sibling_ordered = voronoiConfig.sibling_ordered;
                sibling_orderedRef.current = sibling_ordered;

                sibling = voronoiConfig.sibling;
                
                let voronoi = <Voronoi palettemode={props.palettemode} largeBoard={largeBoard} ref={drawObject} init={true} color="#FFF" gamedata={data.current} Vl={Vl.current} letterVl={letterVl.current} SelectionRef={SelectionRef} level={level}/>
                crossword = React.createElement('div', { ref:CrosswordRef, className:"crossword", style:{marginTop:0, paddingTop:"0px", minHeight: largeBoard? "450px": "368px", width: largeBoard? "450px": "368px"}}, voronoi, <PassedWords ref={PassedWordsRef} largeBoard={largeBoard} Vl={Vl.current} gamedata={data.current} updateUsedRaw = {updateUsedRaw} passed_words={passed_words} players={players} offsetHeight= {offsetHeight} sibling_ordered={sibling_ordered} level={level}/>,<Selection ref={SelectionRef} playersRef={playersRef} AddItemWordHistory={AddItemWordHistory} UpdateStatus={UpdateStatus} largeBoard={largeBoard} makeScaleBoard={makeScaleBoard} muted={props.muted}  ToolTipObj={ToolTipRef} Vl={Vl.current} letterVl={letterVl} passed_words={passed_words} sibling={sibling} sibling_ordered = {sibling_ordered} gamedata={data.current} offsetHeight= {offsetHeight} level={level}/>);
                crossword_an_footer = React.createElement('div', {className:"crossword-and-footer", style:{marginTop:0, paddingTop: "0px", paddingBottom: "0px"}}, crossword);
                grid_area = React.createElement('div', {className:"grid-area scrollable noselect", style:{marginTop:0, paddingTop: "0px", overflow: "hidden", width: "100%"}}, crossword_an_footer);
                pm_xword_body = React.createElement('div', {className:"pm-xword-body puzzle-type-wordsearch3", style:{marginTop:0, paddingTop: "0px", fontFamily: "short_filmsmedium"}}, grid_area);
                mainbody = React.createElement('div', {onMouseOver:(e) => SelectionRef.current.handleBoxToggle(e), className:"main-body", style:{marginTop:0, paddingTop: "0px", textAlign: "center"}}, pm_xword_body);
                
                SetBoard(mainbody);
                break;
            default:
                SetBoard(null);
                break;
        }

    }, [props.gamedata, largeBoard, level, passed_words, props.palettemode])

    function updateUsedRaw(val) {
        SelectionRef.current.updateUsedRaw(val)
    }
    
    

    let multiscore = "";
    
    if (data.current.multigame)
        if (playLevel) {
            multiscore = <MultiScore calcOpenModalFunction = {props.calcOpenModalFunction} show="short" playmode="multi" gameId={data.current.gameId} userId={props.user.uid} user={props.user} passed_words={passed_words} players={players} last_heroes={last_heroes} owner={gameOwnerRef.current} CreateNewMultiGame={props.CreateNewMultiGame}/>   
        } else {
            multiscore = <MultiScore calcOpenModalFunction = {props.calcOpenModalFunction} show="full" playmode="multi"  gameId={data.current.gameId} userId={props.user.uid} user={props.user} passed_words={passed_words} players={players} last_heroes={last_heroes} owner={gameOwnerRef.current} CreateNewMultiGame={props.CreateNewMultiGame}/> 
        }
    else {
        if (!playLevel) 
            multiscore = <MultiScore calcOpenModalFunction = {props.calcOpenModalFunction} show="full" playmode="solo" gameId={data.current.gameId} userId={props.user.uid} user={props.user} players={players} last_heroes={{}} setSwitchChecked={props.setSwitchChecked}/>
    }
   
    if (isFinish && !data.current.multigame) {

        let msg = "Вітаємо, поки що 912 рівень максимальний. Скоро буде нова версія гри, ми повідомимо листом. Дуже вдячні за інтерес, ми працювали для Вас! Ваш досвід для нас дуже цінний, якщо буде час, будь ласка, надішліть свій відгук нам на пошту - mikhalko@gmail.com , що вам сподобалось, а що ні? "
        return <>
            <Header ref={HeaderRef} animate={true} multigame={data.current.multigame} multiscore={multiscore} players={players} />
            <Alert sx={{mt:2}}>{msg}</Alert>
            <Button onClick={()=> {navigate('stat')}} startIcon={<PlayArrowIcon />}> обрати рівень та грати знову!</Button>
            </>
    };

    if ( isFinish && data.current.multigame) {
        let msg = "Гра завершена, вітаємо переможців!"

        return <>
            <Header ref={HeaderRef} animate={true} multigame={data.current.multigame} multiscore={multiscore} players={players} />
            <Alert sx={{mt:2}}>{msg}</Alert>
            <Button onClick={()=>{  props.aMenuRef.current && props.aMenuRef.current.letsOpen()}} startIcon={<PlayArrowIcon />}>обрати іншу гру!</Button>
            </>  
    };

    if (playLevel && !playButtonDisabled) {
        return <>
            <Header ref={HeaderRef} animate={true} multigame={data.current.multigame} multiscore={multiscore} players={players} />
            {(props.user.isAnonymous && 20 < props.gamedata.current_level && 1 == props.gamedata.current_level % 10) && <Login message="Збережи свій рейтинг та словник" currentUser={props.user}/>}
            <ToolTips muted={props.muted} ref={ToolTipRef} HeaderRef={HeaderRef} changeToolTip={changeToolTip} DictWord={DictWord} last_current_word={last_current_word} getCurrentPassedList = {getCurrentPassedList} tooltips={props.gamedata.tooltips} level={props.gamedata.current_level} level_words={props.gamedata.level_words}  level_words2 = {props.gamedata.level_words2} level_words_keys={props.gamedata.level_words_keys}  level_words2_keys = {props.gamedata.level_words2_keys}  item={null} show_all = {false} just_resolved = {false} reverse = {false}/>
            {drawboard}
            <StatusBar ref={statusBarRef} words_count={(passed_words == null) ? data.current.total_words_count : data.current.total_words_count + Object.keys(passed_words).length} level={props.gamedata.current_level} max_level={913}/>
            {/*<Description last_current_word= {last_current_word} tooltips={props.gamedata.tooltips} ref_passed_words={ref_passed_words} level_words = {props.gamedata.level_words} level_words2 = {props.gamedata.level_words2}/>*/}
            </>
    }

    function isGameNew() {
        let gid = data.current.gameId;
        let res = 0;

        props.user.games.current.forEach((item) => {
            if (item[0] == gid) {
                res = item[1].created.seconds;
            }
        });
        
        return res < (Date.now()/ 1000 | 0) - 10*3600;
    }

    function handleOpenInvite() {
        if (process.env.REACT_APP_FACEBOOK_MODE) 
            handleFbFriends({userId: props.user.uid, gameId: data.current.gameId});
        else
            setOpenModalInvite(true);
      }

    return <>
        <Header />
        <Box  sx={{ display: 'flex',justifyContent:"center",
          alignItems: 'flex-center', flexDirection: 'column', minWidth: 275, marginTop: "20px" }}>
        
        {playButtonDisabled && 
            <>{multiscore}
            <ModalInviteFriends open={openModalInviteFriends} handleClose={()=>setOpenModalInvite(false)} gameId={data.current.gameId} userId = {props.user.uid} />
            <Alert style={{marginTop:5}}  severity="warning"><Box display="flex" alignItems="center">Чекаємо на друзів, будь ласка, <Button onClick={handleOpenInvite} endIcon={<PersonAddIcon/>}>запросіть їх!</Button></Box></Alert>
            {props.user.games.current && (1 < props.user.games.current.length) && isGameNew() && <Alert style={{marginTop:5}} variant="h1" severity="info"><Box display="flex" alignItems="center">Або оберіть іншу гру, <Button onClick={()=>{  props.aMenuRef.current && props.aMenuRef.current.letsOpen()}} >перелік</Button>.</Box></Alert>}
            </>
        } 
        
        {!playButtonDisabled && <NextLevelShow play={() => {startPlayLevel(true)}} muted={props.muted} multiscore={multiscore} multigame={data.current.multigame} level={props.gamedata.current_level} />}
        {/*<Stack spacing={2} >
        {(null!=last_words) && <Divider sx={{ marginTop:"25px"}}>Словник</Divider>}
        {(null!=last_words) && last_words.map((item, index) => 
                <Divider key={index} textAlign="left" sx={{"& .MuiDivider-wrapper": {color: "maroon"},  marginTop:"25px"}}>
                    {item[0]}
                </Divider>
            )}
        </Stack>*/}
        </Box>
        </>
    
}